import React from "react";
import { Flex, Space, Button } from "antd";
import { FormInstance } from "antd/es/form";
import { t } from "i18next";
import { observer } from "mobx-react-lite";
import {
  BulkPlanCreationStore,
  CreationStatus,
} from "../../BulkPlanCreationStore";
import styles from "./BulkPlanFooter.module.less";
import { EdBulkPlanCreation } from "../../EdBulkPlanCreation";

interface PropsBulkPlanFooter {
  store: BulkPlanCreationStore;
  form: FormInstance<EdBulkPlanCreation>;
}

export const BulkPlanFooter: React.FC<PropsBulkPlanFooter> = observer(
  ({ store, form }) => {
    const { creationStatus } = store;
    const footerContent: Record<CreationStatus, React.ReactNode> = {
      blocked: null,
      decision: (
        <Flex align="center" justify="end">
          <Space>
            <Button onClick={() => store.onCLose()}>{t("Cancel")}</Button>
            <Button type="primary" onClick={() => store.skipInstances()}>
              {t("Continue without instances")}
            </Button>
          </Space>
        </Flex>
      ),
      canCreate: (
        <Button
          type="primary"
          className={styles.createButton}
          onClick={() => form.submit()}
        >
          {t("Next")}
        </Button>
      ),
    };
    return creationStatus && footerContent[creationStatus];
  },
);
